export var TOKEN_STATUS_MAP = {
    active: {
        iconName: 'CheckCircleRounded',
        iconColor: '#388E3C',
        backgroundColor: '#D9F2DF'
    },
    scheduleCancel: {
        iconName: 'RestoreFromTrashRounded',
        backgroundColor: '#BDBDBD'
    },
    canceled: {
        iconName: 'CancelRounded',
        iconColor: '#212121',
        backgroundColor: '#BDBDBD'
    },
    suspend: {
        iconName: 'PauseCircleFilledOutlined',
        iconColor: '#FFBF4A',
        backgroundColor: '#FFF6E4'
    },
    checkout: {
        iconName: 'CheckCircleRounded',
        iconColor: '#388E3C',
        backgroundColor: '#D9F2DF'
    },
    limitReached: {
        iconName: 'ReportRounded',
        backgroundColor: '#fa4d563a'
    },
    overdue: {
        iconName: 'BuildCircleRounded',
        backgroundColor: '#ffd50031'
    },
    scheduledSuspension: {
        iconName: 'ManageHistoryRounded',
        backgroundColor: '#ffd50031'
    },
    revert: {
        iconName: 'AutorenewRounded',
        backgroundColor: '#a7a7a742'
    },
    inProgress: {
        iconName: 'CheckCircleRounded',
        iconColor: '#388E3C',
        backgroundColor: '#D9F2DF'
    },
    error: {
        iconName: 'ErrorRounded',
        backgroundColor: '#FEEAEB'
    },
    reactivated: {
        iconName: 'RotateLeftRounded',
        iconColor: '#388E3C',
        backgroundColor: '#D9F2DF'
    },
    changed: {
        iconName: 'UpdateRounded',
        backgroundColor: '#ffd50031'
    },
    waitingSuspension: {
        iconName: 'RotateLeftRounded',
        backgroundColor: '#ffd50031'
    },
    waitingCancellation: {
        iconName: 'HourglassEmptyRounded',
        iconColor: '#FFC107',
        backgroundColor: '#ffd50031'
    },
    requested: {
        iconName: 'CheckCircleRounded',
        iconColor: '#388E3C',
        backgroundColor: '#D9F2DF'
    },
    canceledRequest: {
        iconName: 'FreeCancellationRounded',
        backgroundColor: '#BDBDBD'
    },
    suspendedRequest: {
        iconName: 'EventBusyRounded',
        backgroundColor: '#BDBDBD'
    },
    reactivatedRequest: {
        iconName: 'AlarmOnRounded',
        backgroundColor: '#ffd50031'
    },
    changedRequest: {
        iconName: 'PublishedWithChangesRounded',
        backgroundColor: '#ffd50031'
    },
    canceledWithoutActivation: {
        iconName: 'UnpublishedRounded',
        backgroundColor: '#ff832b4b'
    },
    waitingSuspensionDueToOverdue: {
        iconName: 'ScheduleRounded',
        backgroundColor: '#FFF6E4'
    }
};
export var TOKEN_STATUS_ID_MAP = {
    1: 'active',
    2: 'scheduleCancel',
    3: 'canceled',
    4: 'suspend',
    5: 'checkout',
    6: 'limitReached',
    7: 'overdue',
    8: 'scheduledSuspension',
    9: 'revert',
    10: 'inProgress',
    11: 'error',
    12: 'reactivated',
    13: 'changed',
    14: 'waitingSuspension',
    15: 'waitingCancellation',
    16: 'requested',
    17: 'canceledRequest',
    18: 'suspendedRequest',
    19: 'reactivatedRequest',
    20: 'changedRequest',
    21: 'canceledWithoutActivation',
    22: 'waitingSuspensionDueToOverdue',
};
var DEFAULT_STATUS_CONFIG = {
    iconName: 'HelpOutlineRounded',
    iconColor: '#757575',
    backgroundColor: '#F5F5F5'
};
/**
 *
 *
 * @param statusName
 * @returns
 */
export var getTokenStatusConfig = function (statusName) {
    return TOKEN_STATUS_MAP[statusName] || DEFAULT_STATUS_CONFIG;
};
export var getTokenStatusConfigById = function (statusId) {
    var statusKey = TOKEN_STATUS_ID_MAP[statusId];
    return statusKey ? TOKEN_STATUS_MAP[statusKey] : DEFAULT_STATUS_CONFIG;
};
